module.exports = __webpack_public_path__ + "static/media/searchInfo.6d5764d9.svg";